import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { G as c } from "../../Group-Df5qojzI.js";
import { T as l } from "../../Text-DAwpUl9s.js";
import '../../assets/index15.css';const m = "Label-module__asterisk___5fa4G", n = "Label-module__group___4wmpE", u = "Label-module__label___W2uMb", d = "Label-module__rightSection___Dw7cD", e = {
  asterisk: m,
  group: n,
  label: u,
  rightSection: d
}, g = ({ children: o, className: t = "", label: i, rightSection: s, withAsterisk: _ }) => /* @__PURE__ */ a(c, { className: e.group, children: [
  /* @__PURE__ */ r(l, { className: `${e.label} ${t}`, children: o || i }),
  s && /* @__PURE__ */ r("div", { className: e.rightSection, children: s }),
  _ && /* @__PURE__ */ a(l, { "aria-hidden": !0, className: e.asterisk, children: [
    " ",
    "*",
    " "
  ] })
] });
export {
  g as Label
};
